import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { FranchiseValues } from 'src/models/Franchise.model';
import FranchiseForm from '../Layouts/FranchiseForm';
import { useGetFranchiseByIdQuery, useUpdateFranchiseByIdMutation } from 'src/services/FranchiseService';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';

type Props = {
    onClose: () => void;
    selectedFranchiseId: string;
};

const EditFranchiseFormWrapper = ({ onClose, selectedFranchiseId }: Props) => {
    // Form Initial Values
    const [items, setItems] = useState<any>({});

    const { isLoading, isFetching, data } =
        useGetFranchiseByIdQuery(selectedFranchiseId);
    const [updateModeById] = useUpdateFranchiseByIdMutation();

    useEffect(() => {
        if (!isLoading && !isFetching) {
            setItems(data?.data);
        }
    }, [isLoading, isFetching, data]);


    const initialValues: FranchiseValues = {
        name: items?.name || '',
        mobile: items?.mobile || '',
        location: items?.location || "",
    };

    // Validation Schema
    const validationSchema = object().shape({
        name: string().required('Please enter name'),
        mobile: string()
        .required("Please enter mobile number")
        .matches(/^[0-9]{10}$/, {
          message: "Mobile number should contain exactly 10 digits."
        }),
                location: string().required('Please enter location'),
    });
    // Handle Submit
    const handleSubmit = (
        values: FranchiseValues,
        { setSubmitting, resetForm }: FormikHelpers<FranchiseValues>
    ) => {

        updateModeById({ id: selectedFranchiseId, body: values }).then(
            (res: any) => {
                if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                } else {
                    if (res?.data?.status) {
                        showToast("success", res?.data?.message);
                        resetForm();
                        onClose();
                    } else {
                        showToast("error", res?.data?.message);
                    }
                }
                setSubmitting(false);
            }
        );
    };


    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        {(isLoading || isFetching) && (
                            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                                <CircularProgress />
                            </div>
                        )}
                        <FranchiseForm formikProps={formikProps} onClose={onClose} formType='EDIT' />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default EditFranchiseFormWrapper;